export default __webpack_public_path__ + "7ab6ad86f4c8a8f1a522e1b374ed8a53.png";